import { Divider } from '@advanza/ui'
import PopUpNotificationsList from 'components/popUpNotifications/PopUpNotificationsList'
import Page from 'components/ui/Page'

const PopUpNotificationsPage = () => {
    return (
        <Page title="Provider Notifications" hideTop={false} current={''}>
            <div className="p-5 ">
                <Divider m />
                <h1>Provider Notifications</h1>
                <Divider l />
                <PopUpNotificationsList />
            </div>
        </Page>
    )
}

export default PopUpNotificationsPage
